import React from 'react';
import Nabvar from '../Components/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import Footer from '../Components/Footer/Footer';
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp';
import NavbarMobile from '../Components/NavbarMobile/NavbarMobile';
import Cart from '../Components/Cart/Cart';
import { useMediaQuery } from '@react-hook/media-query';

export default function PagesLayaut() {
    const isScreenLarge = useMediaQuery('(min-width: 900px)');

    return (
        <div className='section-bg-color'>
            <Nabvar />
            <div className='espaciobg'></div>
            <Outlet />
            <Footer />
            <Cart />
            <NavbarMobile />
            {isScreenLarge ? <BtnWhatsapp /> : null}
        </div>
    );
}
